// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lpUGou2G_KvDeZnrJ9gV {
  margin-bottom: 1rem
}

.lpUGou2G_KvDeZnrJ9gV.VXFNwr9V9PbCFBj6ouCb {
    margin-bottom: 0.5rem;
  }

.tBcEk_siZ3UMwmbpg6U3 {
  margin-bottom: 1.5rem;
  color: var(--grey-400);
}

.A0ZANc3hBSwit175GyN2 {
  width: 3.5rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  background-color: var(--title-horizontal-rule-color);
}

.cemSQgZCC5Vcpjnkr_j_ {
  margin-bottom: 2.5rem;
}

.N8zUPwEQTm4H3SJodymK {
  --bottom-padding: 2.5rem;

  padding-left: var(--horizontal-padding);
  padding-right: var(--horizontal-padding);
  padding-top: var(--top-padding);
  padding-bottom: var(--bottom-padding);
}

.EQxccI3_QHmFTlPNSUnn {
  --bottom-padding: 2.5rem;

  padding-top: var(--top-padding);
  padding-bottom: var(--bottom-padding);
}

@media only screen and
  (min-width: 1280px) {
  .N8zUPwEQTm4H3SJodymK {
    --horizontal-padding: 4rem;
    --top-padding: 6rem;
  }

  .EQxccI3_QHmFTlPNSUnn {
    --top-padding: 6rem;
  }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .N8zUPwEQTm4H3SJodymK {
    --horizontal-padding: 3rem;
    --top-padding: 5rem;
  }

  .EQxccI3_QHmFTlPNSUnn {
    --top-padding: 5rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .N8zUPwEQTm4H3SJodymK {
    --horizontal-padding: 2rem;
    --top-padding: 4rem;
  }

  .EQxccI3_QHmFTlPNSUnn {
    --top-padding: 4rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .N8zUPwEQTm4H3SJodymK {
    --horizontal-padding: 1rem;
    --top-padding: 3rem;
    --bottom-padding: 1.5rem;
  }

  .EQxccI3_QHmFTlPNSUnn {
    --top-padding: 3rem;
    --bottom-padding: 1.5rem;
  }

  .lpUGou2G_KvDeZnrJ9gV {
    margin-bottom: 0.5rem
  }

    .lpUGou2G_KvDeZnrJ9gV.VXFNwr9V9PbCFBj6ouCb {
      margin-bottom: 0.25rem;
    }

  .cemSQgZCC5Vcpjnkr_j_ {
    margin-bottom: 1.5rem;
  }

  .tBcEk_siZ3UMwmbpg6U3 {
    margin-bottom: 0.75rem;
    color: var(--grey-400);
  }

  .A0ZANc3hBSwit175GyN2 {
    width: 2.5rem;
    height: 0.375rem;
    border-radius: 0.1875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Title/Title.module.css"],"names":[],"mappings":"AAAA;EACE;AAKF;;AAHE;IACE,qBAAkB;EACpB;;AAGF;EACE,qBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAW;EACX,cAAW;EACX,sBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,qBAAmB;AACrB;;AAEA;EACE,wBAAsB;;EAEtB,uCAAuC;EACvC,wCAAwC;EACxC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,wBAAsB;;EAEtB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EACE;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,wBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,wBAAsB;EACxB;;EAEA;IACE;EAKF;;IAHE;MACE,sBAAkB;IACpB;;EAGF;IACE,qBAAmB;EACrB;;EAEA;IACE,sBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,aAAW;IACX,gBAAW;IACX,wBAAkB;EACpB;AACF","sourcesContent":[".title {\n  margin-bottom: 16px;\n\n  &.withSubTitle {\n    margin-bottom: 8px;\n  }\n}\n\n.subTitle {\n  margin-bottom: 24px;\n  color: var(--grey-400);\n}\n\n.seperator {\n  width: 56px;\n  height: 8px;\n  border-radius: 4px;\n  background-color: var(--title-horizontal-rule-color);\n}\n\n.redeemWrapper {\n  margin-bottom: 40px;\n}\n\n.wrapper {\n  --bottom-padding: 40px;\n\n  padding-left: var(--horizontal-padding);\n  padding-right: var(--horizontal-padding);\n  padding-top: var(--top-padding);\n  padding-bottom: var(--bottom-padding);\n}\n\n.verticalWrapper {\n  --bottom-padding: 40px;\n\n  padding-top: var(--top-padding);\n  padding-bottom: var(--bottom-padding);\n}\n\n@media (--desktop-large) {\n  .wrapper {\n    --horizontal-padding: 64px;\n    --top-padding: 96px;\n  }\n\n  .verticalWrapper {\n    --top-padding: 96px;\n  }\n}\n\n@media (--desktop-small) {\n  .wrapper {\n    --horizontal-padding: 48px;\n    --top-padding: 80px;\n  }\n\n  .verticalWrapper {\n    --top-padding: 80px;\n  }\n}\n\n@media (--tablet) {\n  .wrapper {\n    --horizontal-padding: 32px;\n    --top-padding: 64px;\n  }\n\n  .verticalWrapper {\n    --top-padding: 64px;\n  }\n}\n\n@media (--mobile) {\n  .wrapper {\n    --horizontal-padding: 16px;\n    --top-padding: 48px;\n    --bottom-padding: 24px;\n  }\n\n  .verticalWrapper {\n    --top-padding: 48px;\n    --bottom-padding: 24px;\n  }\n\n  .title {\n    margin-bottom: 8px;\n\n    &.withSubTitle {\n      margin-bottom: 4px;\n    }\n  }\n\n  .redeemWrapper {\n    margin-bottom: 24px;\n  }\n\n  .subTitle {\n    margin-bottom: 12px;\n    color: var(--grey-400);\n  }\n\n  .seperator {\n    width: 40px;\n    height: 6px;\n    border-radius: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `lpUGou2G_KvDeZnrJ9gV`,
	"withSubTitle": `VXFNwr9V9PbCFBj6ouCb`,
	"subTitle": `tBcEk_siZ3UMwmbpg6U3`,
	"seperator": `A0ZANc3hBSwit175GyN2`,
	"redeemWrapper": `cemSQgZCC5Vcpjnkr_j_`,
	"wrapper": `N8zUPwEQTm4H3SJodymK`,
	"verticalWrapper": `EQxccI3_QHmFTlPNSUnn`
};
export default ___CSS_LOADER_EXPORT___;
